import { fetch } from '@/plugin/axios/index.js'

/**
 * @param {Object} data
 * 获取故障模板列表
 */
export function getPointTree(data) {
  return fetch ({
    url: '/repair/repair/point/tree',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 保存故障点
 */
export function savePoint(data) {
  return fetch({
    url: '/repair/repair/point/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除故障点
 */
export function deletePoint(data) {
  return fetch({
    url: '/repair/repair/point/delete',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取故障原因下拉列表
 */
export function getFaultReasonList(params) {
  return fetch ({
    url: '/repair/repair/faultReason/simpleList',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 获取故障模板下拉列表
 */
export function getPointTemplateList(params) {
  return fetch ({
    url: '/repair/repair/pointTemplate/simpleList',
    method: 'GET',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/FaultTypesItems/index.js